export const FeatureFlags = {
  Riskjs: "enable_risk_js",
  UseRiskWithIframe: "use_risk_with_iframe",
};

const AvailableFlags = Object.values(FeatureFlags);

/**
 * @param {string} featureFlag The feature flag to check status of
 * @param {{ FEATURE_FLAGS?: { enable_risk_js?: boolean } }} env Environment object containing FEATURE_FLAG map
 * @returns Whether the feature is enabled or disabled in the environment
 */
export function isFeatureEnabled(featureFlag, env) {
  if (!AvailableFlags.includes(featureFlag)) {
    return false;
  }

  return !!(env && env.FEATURE_FLAGS && env.FEATURE_FLAGS[featureFlag]);
}
